import { mapState } from 'vuex';
import chart from '../components/motlet/settings/chart';
import grid from '../components/motlet/settings/grid';
import { mis2Msms } from '../utils/formatter';

export default {
  computed: {
    ...mapState('common/motlet', { motletStates: state => state.motlet }),
    motletId() {
      return this.options?.id || this.motletOptions?.id || this.motlet?.id;
    },
    motletState() {
      return this.motletStates[this.motletId] || {};
    },
    monitor() {
      return this.motletState.monitor;
    },
    descendants() {
      return this.motletState.descendants;
    },
    descendant() {
      return this.motletState.descendant;
    },
    dataParam() {
      return this.motletState.dataParam;
    },
    zoomActive() {
      return this.motletState.zoom?.active;
    },
    zoomRestore() {
      return this.motletState.zoom?.restore;
    },
    chartFields() {
      const code = this.monitor.monitorCodeType ? `${this.monitor.monitorCode}_${this.monitor.monitorCodeType}` : this.monitor.monitorCode;
      const targetChart = chart[code] || {};
      return targetChart.fields || [];
    },
    chartField() {
      return this.motletState.settings?.chart?.field;
    },
    gridFields() {
      if (this.gridCode) {
        const code = this.gridCode + (this.gridCodeType ? this.gridCodeType : '');
        return grid[code].fields;
      } else {
        return [];
      }
    },
    gridSelectedFields() {
      return this.motletState.settings?.grid?.selectedFields;
    },
    taskType() {
      return this.motletState.taskType.selected;
    },
    // BEGIN::Added.by.KWShin.2024.01.12.
    loadKind() {
      return this.motletState.loadKind.selected;
    },
    // FINISH::Added.by.KWShin.2024.01.12.
    // BEGIN::Added.by.KWShin.2024.01.14.
    logonType() {
      return this.motletState.logonType.selected;
    },
    // FINISH::Added.by.KWShin.2024.01.14.
    // BEGIN::Added.by.KWShin.2024.01.25.
    yAxisMax() {
      return this.motletState.yAxisMax.value;
    },
    // FINISH::Added.by.KWShin.2024.01.25.
    // BEGIN::Added.by.KWShin.2024.01.29.
    abapDumpTerm() {
      return this.motletState.abapDumpTerm.value;
    },
    updRecTerm() {
      return this.motletState.updRecTerm.value;
    },
    // FINISH::Added.by.KWShin.2024.01.20.
    // BEGIN::Added.by.KWShin.2024.03.06.
    xAxisPoints() {
      return this.motletState.xAxisPoints.value;
    },
    // FINISH::Added.by.KWShin.2024.03.06.
    gridCode() {
      return this.motletState.settings?.grid?.code;
    },
    gridCodeType() {
      return this.motletState.settings?.grid?.codeType;
    },
    cycles() {
      return this.monitor.cycles.map(cycle => ({
        text: mis2Msms(this.monitor.points * cycle),
        value: cycle,
      }));
    },
  },
  methods: {
    setTaskType(taskType) {
      this.$store.dispatch('common/motlet/setTaskType', { id: this.motletId, taskType });
    },
    // BEGIN::Added.by.KWShin.2024.01.12.
    setLoadKind(loadKind) {
      this.$store.dispatch('common/motlet/setLoadKind', { id: this.motletId, loadKind });
    },
    // FINISH::Added.by.KWShin.2024.01.12.
    // BEGIN::Added.by.KWShin.2024.01.14.
    setLogonType(logonType) {
      this.$store.dispatch('common/motlet/setLogonType', { id: this.motletId, logonType });
    },
    // FINISH::Added.by.KWShin.2024.01.14.
    // BEGIN::Added.by.KWShin.2024.01.26.
    setYAxisMax(yAxisMax) {
      this.$store.dispatch('common/motlet/setYAxisMax', { id: this.motletId, yAxisMax });
    },
    // FINISH::Added.by.KWShin.2024.01.26.
    // BEGIN::Added.by.KWShin.2024.01.26.
    setAbapDumpTerm(abapDumpTerm) {
      this.$store.dispatch('common/motlet/setAbapDumpTerm', { id: this.motletId, abapDumpTerm });
    },
    setUpdRecTerm(updRecTerm) {
      this.$store.dispatch('common/motlet/setUpdRecTerm', { id: this.motletId, updRecTerm });
    },
    // FINISH::Added.by.KWShin.2024.01.26.
    // BEGIN::Added.by.KWShin.2024.04.06.
    setXAxisPoints(xAxisPoints) {
      this.$store.dispatch('common/motlet/setXAxisPoints', { id: this.motletId, xAxisPoints });
    },
    // FINISH::Added.by.KWShin.2024.04.06.
    // BEGIN::Added.by.KWShin.2024.04.07.
    setMonitor(monitor) {
      this.$store.dispatch('common/motlet/setMonitor', { id: this.motletId, monitor });
    },
    // FINISH::Added.by.KWShin.2024.04.07.
    setChartField(code) {
      const field = this.chartFields.find(f => f.code == code);
      this.$store.dispatch('common/motlet/setChartField', { id: this.motletId, field });
    },
    setGridSelectedFields(fields) {
      this.$store.dispatch('common/motlet/setGridSelectedFields', { id: this.motletId, fields });
    },
    setCycle(cycle) {
      this.$store.dispatch('common/motlet/setCycle', { id: this.motletId, cycle });
    },
    setDescendants(systemId) {
      const descendants = this.$store.getters['common/system/getDescendantsById'](systemId);
      this.$store.dispatch('common/motlet/setDescendants', { id: this.motletId, descendants });
    },
  },
};
